export const PER_TYPES = {
  MARKET: 'market',
  GENRE: 'genre',
};

export const REVENUE_TYPES = {
  TOTAL: 'total',
  MOBILE: 'mobile',
  PC: 'pc',
  CONSOLE: 'console',
};

export const REGION_MARKET_TYPES = {
  REGION: 'region',
  MARKET: 'market',
};

export const GENRE_TYPES = {
  MAIN: 'main',
  SUB: 'sub',
  MAIN_SUB: 'main_sub',
};

export const METRICS_TYPES = {
  REVENUE: 'revenue',
  DOWNLOADS: 'download',
};

export const REGION_OPTS = [
  { text: 'dbi_global_view_region', value: REGION_MARKET_TYPES.REGION },
  { text: 'dbi_global_view_core_markets', value: REGION_MARKET_TYPES.MARKET },
];

export const GENRE_OPTS = [
  { text: 'dbi_main_genre', value: GENRE_TYPES.MAIN },
  { text: 'dbi_sub_genre', value: GENRE_TYPES.SUB },
  { text: 'dbi_global_view_main_sub_genre', value: GENRE_TYPES.MAIN_SUB },
];

export const GLOBAL_VIEW_METRICS_OPTS = [
  { text: 'Revenue', value: METRICS_TYPES.REVENUE },
  { text: 'Downloads', value: METRICS_TYPES.DOWNLOADS },
];

// 由于GLOBAL_VIEW_METRICS_OPTS已使用，并且有地方用text字段做了逻辑判断，所以 新加个配置专门用来做翻译的，选项value 和 GLOBAL_VIEW_METRICS_OPTS保持一致
export const GLOBAL_VIEW_METRICS_OPTS_FOR_SEGMENT_LOCALE = [
  { text: 'dbi_revenue', value: METRICS_TYPES.REVENUE },
  { text: 'dbi_global_view_downloads', value: METRICS_TYPES.DOWNLOADS },
];

export const PAGE_LOG_CONFIG_KEYS: any = {
  [`${PER_TYPES.MARKET}_${REVENUE_TYPES.TOTAL}`]: 'globalViewTopGenrePerMarketTotalMarket',
  [`${PER_TYPES.MARKET}_${REVENUE_TYPES.MOBILE}`]: 'globalViewTopGenrePerMarketMobileGames',
  [`${PER_TYPES.MARKET}_${REVENUE_TYPES.PC}`]: 'globalViewTopGenrePerMarketPCGames',
  [`${PER_TYPES.MARKET}_${REVENUE_TYPES.CONSOLE}`]: 'globalViewTopGenrePerMarketConsoleGames',
  [`${PER_TYPES.GENRE}_${REVENUE_TYPES.TOTAL}`]: 'globalViewTopMarketPerGenreTotalMarket',
  [`${PER_TYPES.GENRE}_${REVENUE_TYPES.MOBILE}`]: 'globalViewTopMarketPerGenreMobileGames',
  [`${PER_TYPES.GENRE}_${REVENUE_TYPES.PC}`]: 'globalViewTopMarketPerGenrePCGames',
  [`${PER_TYPES.GENRE}_${REVENUE_TYPES.CONSOLE}`]: 'globalViewTopMarketPerGenreConsoleGames',
};

// 所有echarts图表的颜色配置，配色方案 跟 其他地方不一样，这里单独写一份
export const ECHART_MULTI_ROWS_COLORS = [
  ['#A6C9FF', '#B5EFFF', '#C0EBD2', '#FFF196', '#FFD8AB', '#FFCCCC', '#DFB2ED', '#D2C8FD', '#A9C7C3', '#B8BED1', '#B7C0F8', '#A8D8F9', '#AFF8E9', '#E7F0AD', '#F5DBA7', '#F8BAAA', '#E9A9E3', '#CAB7F8', '#AECCD6', '#B9BEDB', '#ABB5F8', '#94EEF5', '#93F4E0', '#C9F0AD', '#F4D394', '#F8B4B4', '#EDB4F8', '#BCA0F4', '#A9C4D7', '#BEB4D2', '#9CBBF7', '#91E9FB', '#8EF2D0', '#ADF0AD', '#EEDB91', '#FDA4A4', '#FBB7DB', '#E897DF', '#A9B4D7', '#E2D8EB', '#B8C9EB', '#B5E2EB', '#A6D6CC', '#A4D2A4', '#D3CAA5', '#DEB5B5', '#DBAFC6', '#D0AED7', '#B6CAD1', '#D8BDB6', '#94DDF5', '#AFF3F8', '#1C4548', '#F0E2AD', '#F5AA96'],
  ['#5086F3', '#5EC8F1', '#69D19C', '#F5D242', '#F19E55', '#F17C86', '#AD53D4', '#7F6FF1', '#488E89', '#6E7794', '#6F80F1', '#50B2F3', '#5EF1D3', '#D0E15B', '#ECB74E', '#F17555', '#D453C7', '#956FF1', '#5D9AAE', '#737CB7', '#576BF2', '#28DDEB', '#26E9C2', '#94E15B', '#E9A828', '#F26868', '#DC68F2', '#7941E9', '#528AAF', '#7D69A5', '#3976EF', '#22D3F8', '#1DE5A1', '#5BE15B', '#DEB822', '#FC4848', '#F86FB8', '#D12FC0', '#5268AF', '#8966A7', '#7193D8', '#6BC5D8', '#4DAE9A', '#49A549', '#A8954B', '#BE6B6B', '#B75E8D', '#A25DAF', '#6C95A4', '#B27B6C', '#29BCEB', '#5EE7F1', '#76D82D', '#E1C65B', '#EC542C'],
  ['#2648A6', '#307DA6', '#358561', '#A8831D', '#A65B29', '#A64453', '#642787', '#413CA6', '#245552', '#2E3247', '#434F9E', '#306B92', '#39917F', '#7D8737', '#8E6E2F', '#914633', '#803278', '#5A4391', '#385D69', '#555C87', '#4756BC', '#18858D', '#178C75', '#598737', '#8C6518', '#923F3F', '#843F92', '#49278C', '#315369', '#5B4D78', '#224790', '#147F95', '#118A61', '#378737', '#866F14', '#982B2B', '#95436F', '#7E1C74', '#313F69', '#4E3961', '#445882', '#407782', '#2E695D', '#2C632C', '#655A2D', '#724040', '#6E3955', '#613869', '#415A63', '#6B4A41', '#19718D', '#398B91', '#47821B', '#877737', '#8E331A'],
  ['#172F80', '#1F5A80', '#215E45', '#826010', '#803F19', '#802E3D', '#431761', '#292880', '#1B4242', '#141521', '#313975', '#234E6A', '#29695C', '#5B6228', '#675022', '#693325', '#5D2457', '#413169', '#29434C', '#44496B', '#2E3988', '#126167', '#116655', '#416228', '#664A12', '#6A2E2E', '#602E6A', '#351C66', '#243C4D', '#45395A', '#193469', '#0F5C6D', '#0D6446', '#286228', '#61510F', '#6E2020', '#6D3151', '#5B1554', '#242E4D', '#3C2B4B', '#31405F', '#2F565F', '#224C43', '#204820', '#4A4121', '#532F2F', '#50293E', '#47294D', '#2F4148', '#4E362F', '#125267', '#296569', '#345F14', '#625728', '#672513'],
  ['#0F1E59', '#153D59', '#13382A', '#5C410A', '#592911', '#591F2C', '#270D3B', '#1B1C59', '#0A1B1C', '#000000', '#272D54', '#183548', '#1C483F', '#3E431B', '#463617', '#482319', '#3F193B', '#2C2148', '#1C2E34', '#2A2D43', '#222A5E', '#0C4246', '#0B453A', '#2C431B', '#45320C', '#481F1F', '#411F48', '#241345', '#182934', '#2E273D', '#112347', '#0A3F4A', '#094430', '#1B431B', '#42370A', '#4B1515', '#4A2137', '#3E0E39', '#181F34', '#271E34', '#222C40', '#203A40', '#17342E', '#163116', '#322C16', '#382020', '#361C2A', '#301C34', '#202C31', '#352520', '#0C3846', '#1C4548', '#23400D', '#433B1B', '#46190D']
];

export const VISUALIS_TITLES: {
  [key: string]: string;
} = {
  top_5_genres_by_revenue: 'dbi_global_view_top_5_genres_by_revenue',
  top_5_genres_by_downloads: 'dbi_global_view_top_5_genres_by_downloads',
  top_5_regions_by_revenue: 'dbi_global_view_top_5_regions_by_revenue',
  top_5_regions_by_downloads: 'dbi_global_view_top_5_regions_by_downloads',
  top_5_markets_by_revenue: 'dbi_global_view_top_5_markets_by_revenue',
  top_5_markets_by_downloads: 'dbi_global_view_top_5_markets_by_downloads',
};

export const TABLE_SEARCH_PLACEHOLDERS: {
  [key: string]: string;
} = {
  region: 'dbi_global_view_search_any_region',
  market: 'dbi_global_view_search_any_market',
  genre: 'dbi_global_view_search_any_genre',
};

export const TABLE_FIRST_COLUMN_KEYS: {
  [key: string]: string;
} = {
  Genre: 'dbi_global_view_genre',
  Region: 'dbi_global_view_region',
  'Core market': 'dbi_global_view_core_markets',
};

export const TABLE_METRICS_KEYS: {
  [key: string]: string;
} = {
  Revenue: 'dbi_revenue',
  Downloads: 'dbi_global_view_downloads',
};

export const TABLE_METRIC_COLUMNS_KEYS: {
  [key: string]: string;
} = {
  '1st Genre & Revenue': 'dbi_global_view_1st_genre_revenue',
  '2nd Genre & Revenue': 'dbi_global_view_2nd_genre_revenue',
  '3rd Genre & Revenue': 'dbi_global_view_3rd_genre_revenue',
  '1st Genre & Downloads': 'dbi_global_view_1st_genre_downloads',
  '2nd Genre & Downloads': 'dbi_global_view_2nd_genre_downloads',
  '3rd Genre & Downloads': 'dbi_global_view_3rd_genre_downloads',
  '1st Region & Revenue': 'dbi_global_view_1st_region_revenue',
  '2nd Region & Revenue': 'dbi_global_view_2nd_region_revenue',
  '3rd Region & Revenue': 'dbi_global_view_3rd_region_revenue',
  '1st Region & Downloads': 'dbi_global_view_1st_region_downloads',
  '2nd Region & Downloads': 'dbi_global_view_2nd_region_downloads',
  '3rd Region & Downloads': 'dbi_global_view_3rd_region_downloads',
  '1st Markets & Revenue': 'dbi_global_view_1st_markets_revenue',
  '2nd Markets & Revenue': 'dbi_global_view_2nd_markets_revenue',
  '3rd Markets & Revenue': 'dbi_global_view_3rd_markets_revenue',
  '1st Markets & Downloads': 'dbi_global_view_1st_markets_downloads',
  '2nd Markets & Downloads': 'dbi_global_view_2nd_markets_downloads',
  '3rd Markets & Downloads': 'dbi_global_view_3rd_markets_downloads',
};

export const PAGE_GLOBAL_CONTEXT_NAME = 'intelligence_global_view_market_genre';
